// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"265":"component---src-templates-page-tsx","461":"b637e9a5"}[chunkId] + "-" + {"265":"7223282db0b6e184fb58","461":"507dfd8e6c5daefc7db5"}[chunkId] + ".js";
};